import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["messengers", "title", "className"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { useNavMenu } from "../../lib";
import { Menu } from "../../../../shared/ui";
import { BackMenu } from "../../../../features/back-menu/ui";
import styles from "./styles.pcss";
var cnMenuList = cnBem('menu-list', styles);
export var MenuList = /*#__PURE__*/forwardRef(function (props, ref) {
  var messengers = props.messengers,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var items = useNavMenu(messengers);
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnMenuList(null, [className]),
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(Text, {
    align: "left",
    className: cnMenuList('title'),
    color: "primary-invert",
    variant: "body-large"
  }, /*#__PURE__*/React.createElement(BackMenu, {
    shouldRender: isMobile
  }), title), /*#__PURE__*/React.createElement(Menu, {
    items: items
  }));
});